import { User } from '../models/user';

export class PatchProfileSuccess {
    static readonly type = '[User] PatchProfileSuccess';

    constructor(public payload: User) {}
}
